import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F2141 {
  f2141_01: string;    // 退回單號 (FK)
  f2141_02: number;    // 項次
  f2141_04: string | null; // 明細日期
  f2141_07: string;    // 庫號
  f2141_11: string;    // 產品代號
  f2141_11a: string;   // 產品名稱
  f2141_12: string;    // 單位
  f2141_13: number;    // 數量
  f2141_14: number;    // 單價
  f2141_15: number;    // 金額
  f2141_16: number;    // 贈量
  f2141_17: number;    // 數值
  f2141_18: string;    // 明細摘要
  f2141_19: number;    // 數值
  f2141_21: string;    // 訂單編號
  f2141_22: number;    // 訂單序號
}

export interface F2140 {
  f2140_01: string;        // 退回單號 (PK)
  f2140_07: string;        // 庫號
  f2140_11: string | null; // 日期
  f2140_12: string;        // 人員代號
  f2140_13: string;        // 客戶代號
  f2140_14: string;        // 發票號碼
  f2140_15: string;        // 單據說明
  f2140_16: number;        // 總項數
  f2140_17: number;        // 明細金額小計
  f2140_18: number;        // 含稅別
  f2140_19: number;        // 稅額
  f2140_20: number;        // 含稅總金額
  f2140_21: number;        // 已收總金額
  f2140_23: number;        // 交通費
  f2140_25: number;        // 運費
  f2140_28: number;        // 未稅總金額
  f2140_30: string;        // 備註
  f2140_31: string;        // 跳號別
  f2140_80: string;        // 核准狀態
  f2140_91: string;        // 建立人員
  f2140_92: string | null; // 建立日期
  f2140_93: string;        // 修改人員
  details?: F2141[];       // 明細
}

export interface DetailRequest {
  f2141_04?: string;
  f2141_11: string;
  f2141_11a: string;
  f2141_12: string;
  f2141_13: number;
  f2141_14: number;
  f2141_16?: number;
  f2141_18?: string;
  f2141_21?: string;
  f2141_22?: number;
}

export interface CreateRequest {
  f2140_07: string;
  f2140_11: string;
  f2140_12: string;
  f2140_13: string;
  f2140_14?: string;
  f2140_15?: string;
  f2140_18: number;
  f2140_21?: number;
  f2140_23?: number;
  f2140_25?: number;
  f2140_30?: string;
  f2140_31?: string;
  details: DetailRequest[];
}

export interface UpdateRequest {
  f2140_07: string;
  f2140_11: string;
  f2140_12?: string;
  f2140_13: string;
  f2140_14?: string;
  f2140_15?: string;
  f2140_18: number;
  f2140_21?: number;
  f2140_23?: number;
  f2140_25?: number;
  f2140_30?: string;
  details: DetailRequest[];
}

export interface ListResponse {
  data: F2140[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pw2204f1Api = {
  async list(page = 1, size = 20, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pw2204f1', { params });
    return res.data;
  },

  async get(id: string): Promise<F2140> {
    const res = await apiClient.get(`/api/pw2204f1/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F2140> {
    const res = await apiClient.post('/api/pw2204f1', data);
    return res.data;
  },

  async update(id: string, data: UpdateRequest): Promise<F2140> {
    const res = await apiClient.put(`/api/pw2204f1/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pw2204f1/${encodeURIComponent(id)}`);
  },
};
